export const ContentType = {
    TEXT: "ContentType.TEXT",
    MEDIA: "ContentType.MEDIA",
    SURVEY: "ContentType.SURVEY",
    OPTION: "ContentType.OPTION",
    PDF: "ContentType.PDF"
};